<template>
  <div class="carousel_wrap_mobile2">
    <el-carousel :height="carouselHeight" loop arrow="never" :key="pageKey">
      <el-carousel-item v-for="(item, index) in imgList" :key="index"
      :style="{background: `url(${item.src}) no-repeat`, backgroundSize: 'cover', backgroundPosition: currentSource === 'product_lie_5_1' ? 'right' : 'center'}">
        <!-- <img
          :src="item.src"
          alt=""
          class="img_item"
          :key="currentRouteKey"
          :style="{
            height:
              $route.path == '/user_case_detail' ||
              currentSource === 'product_lie_11' ||
              currentSource === 'product_lie_12' ||
              currentSource === 'industry_safety_1' ||
              currentSource === 'industry_safety_2' ||
              currentSource === 'industry_other_4' ||
              currentSource === 'industry_power_2' ||
              currentSource === 'industry_other_2' ||
              currentSource === 'industry_other_5' ||
              currentSource === 'industry_other_3'
                ? carouselHeight
                : '',
          }"
        /> -->
        <!-- 当 item.line1 不为 "集群式换电航站" 时显示 -->
        <div class="ho_top" v-if="$route.path !== '/product_lie'"></div>

        <div
          :class="[
            'tips_font',
            { tips_font_alt: currentSource.indexOf('product_lie') > -1 },
            { tips_font_11: currentSource === 'product_lie_11' },
            { tips_font_12: currentSource === 'product_lie_12' },
            { 'user-case-detail-class': $route.path === '/user_case_detail' },
            { tips_font_5: currentSource === 'product_lie_5' },
          ]"
        >
          <!-- <img src="../../assets/home/iconLogoTxt.png" style="width: 250PX;margin-bottom: 50PX;"
            v-if="currentSource === 'all_user_cases'" /> -->
          <h1
            :class="{
              'industry-h1':
                currentSource.indexOf('industry') > -1 ||
                $route.path === '/user_case_detail',
            }"
            v-if="item.line1 == '变电（换流）站'"
          >
            {{ item.line1 }}
          </h1>
          <h1
            :class="{
              'industry-h1':
                currentSource.indexOf('industry') > -1 ||
                $route.path === '/user_case_detail',
              'industry-h1-2': currentSource === 'product_lie_2',
            }"
            v-else
          >
            {{ item.line1.split("=")[0].split("（")[0]
            }}<span style="color: #106fff">{{ item.line1.split("=")[1] }}</span>
          </h1>
          <div
            class="content"

                     :style="[
                      { width: currentSource == 'product_lie_7' ? '60%' : '' },
              { width: (item.line1 == '系留供电装置' || currentSource == 'product_lie_9' ) ? '65%' : '' }
            ]"
            v-html="item.line2 ? item.line2.replace(/ /g, '&nbsp;') : ''"
            v-if="$route.path !== '/all_user_cases'"
          ></div>
          <div class="content" style="opacity: 1" v-else>
            <span style="opacity: 0.8">深入</span
            ><span style="font-weight: bold; opacity: 1"
              >低空经济、电网、新能源、能源、轨道交通</span
            >
            <span style="opacity: 0.8"
              >等行业，打造全场景应用，助力用户数字化转型与智能化升级</span
            >
          </div>
          <div style="display: flex; justify-content: center; width: 100%">
            <div
              v-if="
                currentSource.indexOf('industry') > -1 &&
                currentSource !== 'industry_power_3' &&
                currentSource !== 'industry_power_4' &&
                currentSource !== 'industry_energy_1' &&
                currentSource !== 'industry_energy_2' &&
                currentSource !== 'industry_hai_yang' &&
                currentSource !== 'industry_energy_3' &&
                currentSource !== 'industry_energy_4' &&
                currentSource !== 'industry_energy_5' &&
                currentSource !== 'industry_other_1' &&
                currentSource !== 'industry_uav_water' &&
                currentSource !== 'industry_guan_wang' &&
                currentSource !== 'industry_uav_safe' &&
                currentSource !== 'industry_uav_forest' &&
                currentSource !== 'industry_uav_delivery' &&
                currentSource !== 'industry_gong_lu' &&
                currentSource !== 'industry_tie_lu' &&
                currentSource !== 'industry_di_tie'
              "
              class="video-full-btn"
              @click="showVideoDialog = true"
            >
              <span>完整视频</span>
              <img
                src="@/assets/home/fangIcon.png"
                alt="fangIcon"
                class="fang-icon"
              />
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- 视频弹窗 -->
    <div
      v-if="showVideoDialog"
      class="video-dialog-mask"
      @click.self="showVideoDialog = false"
    >
      <div class="video-dialog-content">
        <!-- 只有弹窗显示时才渲染 video 元素，关闭时自动销毁 -->
        <video
          v-if="showVideoDialog"
          controls
          autoplay
          style="width: 80%; height: 39vh"
        >
          <source :src="videoUrl" type="video/mp4" />
          您的浏览器不支持 video 标签。
        </video>
      </div>
    </div>
  </div>
</template>

<script>
import { IMG_BASE_URL } from "@/utils/index.js";
export default {
  props: {
    detData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      imgList: [],
      pageKey: 0,
      currentSource: "", // 用于存储当前的 source 参数
      showVideoDialog: false, // 控制弹窗显示
      videoUrl: "https://hr2.chnsoft.com.cn/%E6%89%A7%E6%B3%95-2-9.mp4", // 替换为实际视频路径
      currentRouteKey: 0,
    };
  },
  computed: {
    carouselHeight() {
      // 路由地址为 /industry_application 时高度为 1080PX，否则根据分辨率判断
      // if (this.$route.path === '/industry_application') {
      //   return '1080PX';
      // }
      const h = window.innerWidth || window.screen.width;
      if (h > 1000) {
        return "460PX";
      } else if (h > 765) {
        return "365PX";
      } else {
        return "200PX";
      }
    },
    getTitleWithoutBrackets(title) {
      // 去除括号及其内容（支持中文和英文括号）
      return title ? title.replace(/[\(\（][^\)\）]*[\)\）]/g, "").trim() : "";
    },
  },
  created() {
    this.updateImgList();
    this.currentSource =
      new URLSearchParams(window.location.search).get("source") || "";
  },
  watch: {
    // 监听 detData 变化，优先更新 imgList
    // detData: {
    //   deep: true,
    //   immediate: true,
    //   handler(newVal) {
    //     if (newVal && Object.keys(newVal).length > 0) {
    //       console.log('detData updated:', newVal);
    //       this.imgList = [
    //         {
    //           src: newVal.src || '',
    //           line1: newVal.line1 || '',
    //           line2: newVal.line2 || '',
    //         },
    //       ];
    //     } else {
    //       this.updateImgList();
    //     }
    //   },
    // },
    $route(to, from) {
      this.currentRouteKey += 1; // 每次路由变化时，更新 key
      // 其他路由变化时的逻辑...
    },
    // 监听 URL 的变化
    "$route.fullPath": {
      immediate: true,
      handler() {
        const urlParams = new URLSearchParams(window.location.search);
        const source = urlParams.get("source");
        // if (source !== this.currentSource) {
        this.currentSource = source;
        // 只有当 detData 为空时才根据 source 更新
        if (!this.detData || Object.keys(this.detData).length === 0) {
          if (this.imgList.length && this.imgList[0]) {
            this.imgList[0].src = "";
          }
          this.updateImgList();
        }
        // }
      },
    },
  },
  methods: {
    updateImgList() {
      // 如果 detData 有内容，优先使用 detData
      if (this.detData && Object.keys(this.detData).length > 0) {
        // 处理 img 字符串，按逗号分隔取第一个
        const imgPath = (this.detData.img || "").split(",")[0];
        this.imgList = [
          {
            src: imgPath
              ? imgPath
              : "https://hr2.chnsoft.com.cn/img/userCaseTopImg.png",
            line1:
              this.detData.title ||
              "某城市智能交通管理解决方案：移动式智能航空站",
            line2:
              "项目地点：" +
              this.detData.address +
              "   " +
              "项目时间：" +
              this.detData.time,
          },
        ];
        return;
      }
      this.imgList = [
        {
          src: "",
          line1: "",
          line2: "",
        },
      ];
      // this.pageKey++
      const selectedText = localStorage.getItem("selectedText") || ""; // 获取 localStorage 中的 selectedText
      if (!selectedText) {
        this.$router.push({ path: "/home" }); // 跳转到首页
      }
      switch (this.currentSource) {
        case "product_lie_1":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/product_lie_1.png",
              line1: selectedText,
              line2:
                "集群式换电航站，搭载两架无人机，双机协同工作，可同时执行不同的作业任务或交替执行同一任务，确保“飞的准”“飞的稳”“一直飞”“交替飞”“协同飞”。",
            },
          ];
          break;
        case "product_lie_2":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/product_lie_2.png",
              line1: selectedText,
              line2:
                "换电式自动机场系列产品是专为工业无人机打造的智能化作业中枢，适配多类型轻小型无人机。集成电池快换、环境感知、远程控制等核心功能，实现无人机“作业-换电-再作业”全流程自动化，突破续航瓶颈，赋能高效作业闭环。",
            },
          ];
          break;
        case "product_lie_3":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/product_lie_3.png",
              line1: selectedText,
              line2:
                "充电式自动机场采用轻量化设计，适配多类型轻小型无人机，是集智能充电、自主起降、通讯保障、环境感知、远程控制等核心功能的一体化无人机自主作业平台，部署方便、经济便捷。",
            },
          ];
          break;
        case "product_lie_4":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/product_lie_4.png",
              line1: selectedText,
              line2:
                "垂起固定翼机场作为垂起固定翼系列无人机的停靠站、通信站和换电站，为垂起固定翼无人机提供一站式保障服务，在无人值守的状态下，依靠该终端能够实现无人机智能化巡查、巡检、巡逻与应急处置等多用途行业综合应用。",
            },
          ];
          break;
        case "product_lie_5":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/product_lie_5.png",
              line1: selectedText,
              line2:
                "大载重自动机场为DJI FlyCart30无人机量身打造，兼顾无人机电池与载荷双重自动更换功能。航空站内部储存多组无人机备用电池与灭火弹（载荷可定制），具备自主起降、自动更换、精准投递、智能决断等突出特点，满足消防、运输、救援多种场景部署使用。",
            },
          ];
          break;
        case "product_lie_5_1":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/product_lie_5_1.png",
              line1: selectedText,
              line2:
                "IAS-D441空地一体母站，是集空地协同、群体智能与智能保障于一体的新一代无人化作业基础设施；可为站内两架无人机与一台四足机器人进行集群调度、任务规划、自动换电/充电等全流程运维支持；凭借工业级温湿调控、强电磁兼容设计与长效UPS供电，确保在极端环境下为整个无人化作业集群提供持续、稳定的支援与保障。",
            },
          ];
          break;
        case "product_lie_6":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/product_lie_6.png",
              line1: selectedText,
              line2:
                "“移动航空站”将越野皮卡与智能航空站有机整合，构建空地协同移动作业平台。具备复杂地形适应能力，支持无人机全自动起降、异地起降、自主跟随、断点续飞等实用功能。依托车载操控终端，实现航线规划、自主飞行、数据采集与AI智能识别的全流程自动化，极大提升野外巡检作业的效率与范围。",
            },
          ];
          break;
        case "product_lie_7":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/product_lie_7.png",
              line1: selectedText,
              line2:
                "一站式空地协同移动作业平台。可同时集控4架无人机，实现无人机全自动起降、异地起降、自主跟随、断点续飞等实用功能。融合5G通信、远程会议、数据分析、图像处理等多项技术手段，可作为应急移动指挥系统，实现前沿视频图像采集、AI智能识别与现场决策指挥，满足户外巡检、应急救援等各类应用场景需求，提升作业、指挥效率与响应速度。",
            },
          ];
          break;
        case "product_lie_8":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/product_lie_8.png",
              line1: selectedText,
              line2:
                "本产品基于成熟消防车平台改装，融合无人驾驶、无人机自动机场及智能火情识别系统。无人机空中自主巡火与定位，智能消防车自动行驶抵近灭火。形成“空中侦察-定位-地面无人精准灭火”的陆空协同作业闭环，有效提升灭火效率并保障人员安全，适用于化工、森林等多种复杂火灾场景。",
            },
          ];
          break;
        case "product_lie_9":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/product_lie_9.png",
              line1: selectedText,
              line2:
                "陆空协同应急处置机器人，首创无人化陆空协同立体消防作业平台。集成了智能消防无人机、高效水雾炮系统、全地形底盘、自主导航避障系统与远程集控平台，构建了完整的无人化陆空协同消防作业体系。具备全天候、全地形作战能力，可在火灾初期快速介入，实现“侦测-定位-压制”一体化作战，有效执行高危环境下的灭火任务，显著提升灭火效率，最大限度保障人员安全与现场秩序。",
            },
          ];
          break;
        case "product_lie_8_1":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/product_lie_8_1.png",
              line1: selectedText,
              line2:
                "陆空协同智能巡视机器人，陆空协同巡火、灭火作业平台，空中无人机高效巡视，精准定位火源，无人机器人全天候、全地形自主出击，可在火灾初期快速介入，实现“侦测-定位-压制”一体化作战，有效执行高危环境下的灭火任务，显著提升灭火效率，最大限度保障人员安全与现场秩序。	",
            },
          ];
          break;
        case "product_lie_8_2":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/product_lie_8_2.png",
              line1: selectedText,
              line2:
                "室内应急处置机器人体积小巧，具备室内自动导航定位、火源定位、应急处置等功能，可穿梭在室内复杂环境中，对室内设施进行巡检、灭火等综合应用。",
            },
          ];
          break;
        case "product_lie_10":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/product_lie_10.png",
              line1: "海空协同无人船 ( 艇 ) ",
              line2:
                "本产品是集自主航行、无人机协同与模块化任务载荷于一体的水上智能作业中枢。无人艇具备AI导航与持久续航能力；集成抗浪涌航空站，确保无人机在复杂海况下精准起降。通过船体与无人机、水下机器人（选配）的协同作业，同步采集水面、空中及水下多维数据，一键生成立体监控网络，全流程自主完成环保监测、应急救援与海域巡检等任务，以智能化手段显著提升作业安全性与效率。",
            },
          ];
          break;
        case "product_lie_11":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/product_lie_11.png",
              line1: "智能全域巡视系统",
              line2:
                "是面向立体空间的全维度无人化智能巡视解决方案，核心实现空、地、海无人装备作业的一体化管控，突破多场景壁垒，织就贯通空、地、海立体巡视网，依托于异构协同、人工智能、边缘计算等新兴技术，实现从装备调度到数据研判的全链条自动化，为各领域筑牢高效精准的全域态势感知屏障。",
            },
          ];
          break;
        case "product_lie_12":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/product_lie_12.png",
              line1: "全域电网巡检系统",
              line2:
                "聚焦输电、变电、配网、直流四大核心专业，以无人机、无人车为核心作业单元，深度融合数字孪生、AI 智能分析、北斗高精度定位等前沿技术，构建覆盖“空-天-地”一体化的全域无人化巡检体系。系统打通从任务智能规划、自主巡检执行、缺陷智能识别到运维闭环管控的全业务链条，彻底颠覆传统人工巡检模式，为电网运维提供安全、高效、精准的数字化、智能化升级解决方案，筑牢新型电力系统安全稳定运行基石。",
            },
          ];
          break;
        case "product_lie_13":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/product_lie_13.png",
              line1: "机载智能大脑",
              line2:
                "机载智能算力核心，赋予无人机自主态势感知、自主决策自主执行和集群协同作业能力。",
            },
          ];
          break;

        case "product_lie_13_1":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/product_lie_13_1.png",
              line1: "车(船)载智能大(小)脑",
              line2:
                "车（船）载智能算力核心，赋予无人车（机器人）、无人船自主态势感知、自主决策自主执行和集群协同作业能力。",
            },
          ];
          break;
        case "product_lie_13_2":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/product_lie_13_2.png",
              line1: "边端算力服务器",
              line2: "边缘算力节点，为全系列产品提供智能决策支撑。",
            },
          ];
          break;
        case "product_lie_14":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/product_lie_14.png",
              line1: "云端算力服务器",
              line2: "云端算力核心，为全系列产品提供智能决策支撑",
            },
          ];
          break;
        case "product_lie_15":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/product_lie_15.png",
              line1: "系留供电装置",
              line2:
                "系留供电装置具备坚固耐用、运行稳定、功能丰富、携带便捷等特点，通过复合线缆为无人机提供不低于8小时的稳定供电，最高作业高度可达百米，解决无人机长时间滞空作业难题，突破无人机续航限制。",
            },
          ];
          break;
        case "product_lie_16":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/product_lie_16.png",
              line1: "无人装备便携地面站",
              line2: "以智能集控重新定义无人机作业边界，让效率与安全触手可及",
            },
          ];
          break;
        case "product_lie_17":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/product_lie_17.png",
              line1: "无人装备驾控台",
              line2: "以中枢智慧赋能无人机集群，让指挥更精准、协同更无界",
            },
          ];
          break;
        case "product_lie_18":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/product_lie_18.png",
              line1: "AMS-400-V112 机载任务系统",
              line2: "轻量化智能核心，赋能无人机精准作业",
            },
          ];
          break;

        case "industry_uav_safe":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_uav_safe.jpg",
              line1: "无人+公共安全",
              line2:
                "无人装备系统为公共安全筑起智慧防线，以精准、高效、智能、全天候的特性，重塑公共安全保障模式，成为守护社会安宁的先锋力量。	",
            },
          ];
          this.videoUrl = "";
          break;
        case "industry_uav_forest":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_uav_forest.jpg",
              line1: "无人+森林",
              line2:
                "无人装备凭借其灵活智能、高效安全的特点，成为现代化生态管理的强力助手。无论是森林巡查、火情监测、资源勘测，还是应急物资投送，均能精准覆盖复杂地形，大幅降低人力风险与作业成本。以科技之力守护自然，让无人装备为森林可持续发展提供创新解决方案。",
            },
          ];
          this.videoUrl = "";
          break;
        case "industry_uav_water":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_uav_water.jpg",
              line1: "无人+水利",
              line2:
                "无人装备凭借高效精准、安全可靠、灵活低耗的独特优势，为水利行业提供智能化解决方案。无论是水库大坝巡检、河道隐患排查、水质动态监测，还是防汛应急响应，无人装备均可深入高危、复杂环境，7×24小时全天候作业，以数据驱动决策，助力打造“感知-预警-管控”一体化智慧水利体系，推动水利管理迈向数字化、精细化新时代。",
            },
          ];
          this.videoUrl = "";
          break;
        case "industry_uav_delivery":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_uav_delivery.png",
              line1: "无人+投送",
              line2:
                "凭借快速响应、精准灵活、降本增效的卓越性能，我们的无人装备在短距离投送领域展现出革命性优势。无需复杂基础设施，无惧复杂地形，以智能化的方式高效完成物资配送、应急救援及战术支援，为现代物流与行动部署提供可靠助力。",
            },
          ];
          this.videoUrl = "";
          break;

        case "industry_guan_wang":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_guan_wang.jpg",
              line1: "管网",
              line2:
                "无人装备以无人化、智能化、集群化为核心优势，为管网巡检提供革命性解决方案：通过无人机等设备快速覆盖复杂环境，AI技术精准识别隐患，7×24小时无间断作业，大幅降低人工风险与运维成本，助力构建更安全、更高效的现代化管网管理体系",
            },
          ];
          this.videoUrl = "";
          break;

        case "industry_gong_lu":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_gong_lu.jpg",
              line1: "公路",
              line2:
                "以精准巡检、智能监测、快速响应、高效协同等优势，全方位提升公路管理效能，护航公路安全畅通，引领公路智能化发展新方向。",
            },
          ];
          this.videoUrl = "";
          break;
        case "industry_tie_lu":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_tie_lu.jpg",
              line1: "铁路",
              line2:
                "以智能科技重塑铁路安全新范式，实现7×24小时立体化巡检、故障实时诊断、零接触风险防控与全链路数据洞察，驱动铁路运营向更高效、更安全、更智能的未来跃迁。	",
            },
          ];
          this.videoUrl = "";
          break;
        case "industry_di_tie":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_di_tie.jpg",
              line1: "地铁",
              line2:
                "无人装备深入地铁运维，实现轨道交通行业无人化、 常态化、 智能自主的巡察作业模式，精准守护城市地下交通动脉，领航地铁运维新纪元。		",
            },
          ];
          this.videoUrl = "";
          break;
        case "industry_hai_yang":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_hai_yang.png",
              line1: "海洋",
              line2:
                "无人装备以智能、安全、高效的方式重塑海洋探索，凭借自主性、持久性与适应性，突破深远海与高危区限制，实现24小时作业；依托先进传感器与AI算法提升决策精度，降低人员风险；覆盖测绘、环保、巡检、国防等多场景，重构海洋生产力，为智慧海洋时代打造轻盈强韧的‘数字之翼’。",
            },
          ];
          this.videoUrl = "";
          break;

        case "industry_power_1":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_power_1.png",
              line1: "输电线路",
              line2:
                "破解输电线路巡检低效、高险难题，无人机集群协同+国产AI多模态大模型+物联网感知技术构建全流程无人化巡检与隐患快速诊断，大幅提升效率，实现输电网络无人化智慧运维，为电网安全运行提供智能化解决方案。",
            },
          ];
          this.videoUrl =
            "https://hr2.chnsoft.com.cn/%E8%BE%93%E7%94%B5%E5%B7%A1%E6%A3%80.mp4";
          break;
        case "industry_power_2":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_power_2.jpg",
              line1: "变电（换流）站",
              line2:
                "为变电（换流）站巡检赋能添智，突破强电磁干扰环境下人工巡检盲区多、效率低、安全风险高等难题。无人机集群协同作业，自主飞行于复杂电磁与设备密集之境，国产AI多模态大模型缺陷诊断精准洞察设备缺陷、高效运维，革新传统作业模式，守护电网安稳脉动。",
            },
          ];
          this.videoUrl =
            "https://hr2.chnsoft.com.cn/%E5%8F%98%E7%94%B5%E5%B7%A1%E6%A3%80-%E8%A1%8C%E4%B8%9A%E5%BA%94%E7%94%A8.mp4";
          break;
        case "industry_power_3":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/indust_power_3.png",
              line1: "配网",
              line2:
                '针对配网设备分散、工况复杂等运维痛点，无人机集群+国产AI多模态大模型+边缘智能终端构建配电场景全域无人巡检体系，实现城市密集区、复杂廊道等场景全天候自主巡检，推动配电网运维向"数字驱动、主动预警"模式升级。',
            },
          ];
          break;
        case "industry_power_4":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_power_4.jpg",
              line1: "直流",
              line2:
                '空地一体多类型无人化装备打造直流专业全场景无人化巡检应急体系，实现换流站设备立体精准监测与火情联动处置，系统深度适配直流数字化平台，推动电网直流专业运维向"零干预、全闭环"模式升级。',
            },
          ];
          break;
        case "industry_energy_1":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_energy_1.jpg",
              line1: "光伏发电",
              line2:
                "应用无人机自主巡检与多模态AI诊断技术，构建光伏电站全维感知数字孪生体系，融合红外热成像、智能缺陷检测及三维建模技术，精准破解组件隐裂、热斑异常及灰尘遮蔽难题，重塑智能运维新范式，引领绿色能源智慧化变革。",
            },
          ];
          break;
        case "industry_energy_2":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_energy_2.jpg",
              line1: "风力发电",
              line2:
                "聚焦风电场广域分布、复杂环境与人工效能瓶颈，融合高精度无人机、AI智能诊断及多模态感知技术，构建“空天地一体化”智能巡检体系。通过智能无人机集群实现叶片微裂纹溯源、塔筒形变动态追踪及海上设施腐蚀监测，革新传统运维模式，驱动风电运维向无人化、智能化跃迁。",
            },
          ];
          break;
        case "industry_energy_3":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_energy_3.jpg",
              line1: "抽水蓄能",
              line2:
                "在抽水蓄能行业，无人巡检技术正逐渐成为提升设施监控效率和安全性的关键工具。通过搭载高清摄像头、红外热成像仪等先进设备，无人设备能够对水库大坝、输水隧道、发电机组等关键设施进行高效、精确的巡检。不仅提高了作业的安全性和效率，还为行业的智能化转型提供了强有力的支持。",
            },
          ];
          break;
        case "industry_energy_4":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_energy_4.jpg",
              line1: "石油",
              line2:
                "传统石油巡检及消防方式面临效率低、风险高、难以全面覆盖等问题。依托无人机集群、AI多模态分析系统及无人应急处置技术构建“高空巡检-地面处置-数据闭环”的全域安防体系，推动石油行业向“本质安全+智能应急”的智慧化转型。",
            },
          ];
          break;
        case "industry_energy_5":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_energy_5.jpg",
              line1: "天然气",
              line2:
                "重构“空中监测-地面处置-云端溯源”全链路天然气行业防控体系，无人机高效巡检场站、管道及储罐，无人车迅速应对火灾等紧急情况，二者结合减少人工风险，优化资源配置，支持行业的智能化转型。",
            },
          ];
          break;
        case "industry_safety_1":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_safety_1.jpg",
              line1: "无人+执法",
              line2:
                "无人装备与多模态智能感技术融合，构建“空地一体、人机协同”全域作战体系。通过无人装备动态巡查、AI行为分析，实现重点区域精准布防、突发事件快速响应，推动执法模式向数据驱动跃迁，推动智慧警务发展。",
            },
          ];
          this.videoUrl =
            "https://hr2.chnsoft.com.cn/%E6%89%A7%E6%B3%95-2-9.mp4";
          break;
        case "industry_safety_2":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_safety_2.jpg",
              line1: "无人+应急",
              line2:
                "创新打造无人机全域侦察、陆空协同无人消防车智能灭火、应急处置机器人高危作业三位一体救援体系，革新传统灾害应对方式，提升应急响应速度与效率，增强复杂环境下的作业能力，推动应急管理向智能化、精细化、高效化方向发展。",
            },
          ];
          this.videoUrl =
            "https://hr2.chnsoft.com.cn/%E5%BA%94%E6%80%A5%E8%A7%86%E9%A2%91-2-10-%E8%A1%8C%E4%B8%9A%E5%BA%94%E7%94%A8.mp4";
          break;
        case "industry_other_1":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_other_1.jpg",
              line1: "轨道交通",
              line2:
                "无人机智能巡检技术革新轨道交通行业传统运维方式，通过高精度导航、多功能负载、智能感知与AI分析能力，成为轨道交通运维领域的创新解决方案。",
            },
          ];
          break;
        case "industry_other_2":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_other_2.jpg",
              line1: "边海防",
              line2:
                "构建“空天地一体化”立体监控网络，实现全天候、全时域精准巡查，保障国土安全，打击非法活动，提升应急响应效率，推动边海防工作智能化、高效化发展。",
            },
          ];
          this.videoUrl =
            "https://hr2.chnsoft.com.cn/%E8%BE%B9%E6%B5%B7%E9%98%B2-2023-4-18-%E8%BD%AC%E7%A0%81.mp4";
          break;
        case "industry_other_3":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_other_3.jpg",
              line1: "矿业",
              line2:
                "通过无人机自主巡检技术革新矿业安全管理，依托高精度定位、AI智能分析与全天候作业能力，实现安全零风险、效率最大化及资源可持续管理，守护矿区安全与价值。",
            },
          ];
          this.videoUrl =
            "https://hr2.chnsoft.com.cn/%E7%9F%BF%E5%B1%B1-2023-4-18-%E8%BD%AC%E7%A0%81.mp4";
          break;
        case "industry_other_4":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_other_4.jpg",
              line1: "无人+环保",
              line2:
                "无人机与无人船构建立体监测网络，实现多维度生态环境精准巡检，突破时空限制，提升生态风险预警及污染溯源能力，助力绿色低碳发展目标。",
            },
          ];
          this.videoUrl =
            "https://hr2.chnsoft.com.cn/%E7%8E%AF%E4%BF%9D-2023-4-18-%E8%BD%AC%E7%A0%81.mp4";
          break;
        case "industry_other_5":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_other_5.jpg",
              line1: "港口",
              line2:
                "聚焦港口作业高密度、多模态风险挑战，构建“无人机空域监测+无人船水域巡查+无人车陆域处置”的“空天地水”全域智能防控网络。实现港口全天候自主巡检、智能消防与应急响应，提升风险预警与处置能力，领航港口运营新标准。",
            },
          ];
          this.videoUrl =
            "https://hr2.chnsoft.com.cn/%E6%B8%AF%E5%8F%A3%E6%96%B0%E8%A7%86%E9%A2%91-%E7%94%A8%E6%88%B7%E6%A1%88%E4%BE%8B-%E8%A1%8C%E4%B8%9A%E5%BA%94%E7%94%A8-%E5%85%AC%E7%94%A8.mp4";
          break;
        case "industry_other_6":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/industry_other_6.jpg",
              line1: "基础建设",
              line2:
                "打造“空中巡检+远程指挥+数据闭环”智能协同体系，驱动全流程数字化监管升级，提升工程管理精度与施工安全水平，引领传统基建向“精准管控、风险预判、低碳高效”的新一代智慧基建跨越。",
            },
          ];
          this.videoUrl = "https://hr2.chnsoft.com.cn/222.mp4";
          break;
        case "all_user_cases":
          this.imgList[0].src = "";
          this.imgList = [
            {
              src: "https://hr2.chnsoft.com.cn/img/userCaseTop.png",
              line1: "华软股份为用户打造卓越案例",
              line2:
                "深入低空经济、电网、新能源、能源、轨道交通等行业，打造全场景应用，助力用户数字化转型与智能化升级",
            },
          ];
          break;
        //         case 'user_case_detail':
        // this.imgList = [
        //   {
        //     src: require('@/assets/home/userCaseTopImg.png'),
        //     line1: '某城市智能交通管理解决方案：移动式智能航空站',
        //     line2: '深入电力、能源、公共安全等行业，打造全场景应用，助力用户数字化转型与智能化升级',
        //   },
        // ];
        // break;

        default:
          this.imgList = []; // 清空 imgList 以防止显示旧数据
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.carousel_wrap_mobile2 {
  position: relative;
  // margin-top: 40PX;

  .ho_top {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    background: linear-gradient(
      180deg,
      rgba(28, 54, 93, 0.9) 0%,
      rgba(28, 54, 93, 0.3) 100%,
      rgba(28, 54, 93, 0) 100%
    );
  }

  .el-carousel__item {
    height: 100%;

    // display: flex;
    img {
      /* 让图片宽度自适应容器，高度自适应原始比例，不拉伸不裁剪 */
      width: 100%;
      height: auto;
      display: block;
      margin: 0 auto;
      // height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }

  .tips_font {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 5;
    color: #fff;
    font-size: 25px;
    width: 100%;
    width: 100%;
    height: 100%;
    justify-content: center;
    display: flex;
    flex-direction: column;

    h1 {
      text-align: center;
      color: #fff;
      font-size: 16px;
      font-weight: 600;
    }

    .content {
      padding: 10px 36px;
      font-size: 10px;
      color: #fff;
      font-weight: normal; // 不加粗

      opacity: 0.8;
      width: 100%;
      font-family: PingFang TC;

      font-weight: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #ffffff;
      text-align: center;
    }
  }

  .tips_font_alt {
    position: absolute;
    // top: 70PX; // 修改位置
    left: 0;
    z-index: 5;
    // color: #ff0; // 修改字体颜色
    font-size: 15px; // 修改字体大小
    // top: 17%;
    width: 100%;
    text-align: center; // 居中对齐

    h1 {
      text-align: left;
      padding-left: 9%;
      font-size: 16px; // 修改字体大小
      font-weight: 600;
    }

    .content {
      padding: 10px 9%; // 修改内边距
      font-size: 8px; // 修改字体大小
      line-height: 1.5;
      opacity: 0.8; // 修改透明度
      width: 57%;
      text-align: justify;
    }
  }

  .tips_font_11 {
    position: absolute;
    // top: 50PX; // 修改位置
    left: 0;
    z-index: 5;
    // color: #ff0; // 修改字体颜色
    font-size: 15px; // 修改字体大小
    width: 100%;
    text-align: left; // 居中对齐

    h1 {
      text-align: left;
      padding-left: 9%;
      font-size: 15px; // 修改字体大小
      color: #1e242a; // 修改字体颜色
      font-weight: 600;
    }

    .content {
      padding: 2% 9%; // 修改内边距
      font-size: 10px; // 修改字体大小
      color: #1e242a; // 修改字体颜色
      opacity: 0.8; // 修改透明度
      width: 70%;
      text-align: left;
    }
  }

  .tips_font_5 {
    // top: 22PX; // 修改位置

    .content {
      padding-left: 6%;
    }

    h1 {
      padding-left: 6%;
      font-weight: 600;
    }
  }

  .tips_font_12 {
    position: absolute;
    // top: 40PX; // 修改位置
    left: 0;
    z-index: 5;
    // color: #ff0; // 修改字体颜色
    font-size: 15px; // 修改字体大小
    width: 100%;
    text-align: left; // 居中对齐

    h1 {
      text-align: left;
      padding-left: 9%;
      font-size: 15px; // 修改字体大小
      color: #1e242a; // 修改字体颜色
      font-weight: 600;
    }

    .content {
      padding: 2% 9%; // 修改内边距
      padding-left: 9%;
      font-size: 10px; // 修改字体大小
      color: #1e242a; // 修改字体颜色
      opacity: 0.8; // 修改透明度
      width: 70%;
      text-align: left;
    }
  }

  .video-full-btn {
    display: inline-flex;
    align-items: center;
    border: 1px solid #fff;
    background: rgba(255, 255, 255, 0.2);
    color: #fff;
    border-radius: 4px;
    padding: 3px 9px 3px 9px;
    font-size: 7px;
    margin: 0px auto 0 auto;
    cursor: pointer;
    transition: background 0.2s;
    box-sizing: border-box;
    height: 20px;
    width: 60px;

    span {
      color: #fff;
      // margin-right: 10PX;
      font-size: 7px;
      letter-spacing: 1px;

      font-family: PingFang SC;

      font-weight: normal;
      line-height: normal;
      letter-spacing: 0px;

      color: #ffffff;
    }

    .fang-icon {
      width: 8px;
      height: 8px;
      display: inline-block;
      vertical-align: middle;
    }
  }
}

.video-dialog-mask {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-dialog-content {
  background: #222;
  padding: 0;
  border-radius: 10px;
  max-width: 180vw;
  // max-height: 80vh;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  // width: 1600PX;
}

.el-carousel__indicator.is-active button {
  display: none;
}

/* 新增 industry-h1 样式 */

/* 新增 user-case-detail-class 样式 */
.user-case-detail-class {
  top: 320px;
}

::v-deep .el-carousel__button {
  display: none;
}
</style>
